<div class="pricing-container position-relative d-flex flex-column align-items-center justify-content-center">
  <mat-icon class="back-arrow position-absolute top-0 start-0 m-3"
    [routerLink]="['/student-dashboard/home']">arrow_back</mat-icon>

  <h2 class="pricing-title">Choose your Plan</h2>

  <p class="pricing-subtitle mb-5">Unlock your full potential with BeExpert's career preparation platform</p>

  <!-- <div class="toggle-wrapper">
        <button class="toggle-btn" [class.active]="isMonthly" (click)="switchPlan(true)">
            Monthly
        </button>
        <button class="toggle-btn" [class.active]="!isMonthly" (click)="switchPlan(false)">
            Yearly
        </button>
    </div> -->

  <div class="plans-wrapper">
    <ng-container *ngIf="isMonthly; else yearlyPlans">
      <ng-container *ngTemplateOutlet="monthlyPlans"></ng-container>
    </ng-container>

    <ng-template #yearlyPlans>
      <ng-container *ngTemplateOutlet="yearlyPlansTemplate"></ng-container>
    </ng-template>
  </div>

  <!-- Monthly Template -->
  <ng-template #monthlyPlans>
    <div class="plan-cards">

		<!-- basic -->
		 <ng-container *hasPermission="PermissionForStudents.PRODUCT_PACKAGES">
      <div class="plan-card basic" *ngIf="studentPackages">

        <div class="card-content">
          <h3>{{studentPackages.product_name}}</h3>

          <div class="mb-2 price-wrapper">
            <span class="price text-center">
              <i class="bi bi-currency-rupee"></i>{{studentPackages.price}} </span>
          </div>

          <p class="content">Complete career preparation with advanced learning and mentorship support.</p>
          <hr />

          <div class="test text-start">What's Included :</div>

          <ul class="list-unstyled features-list">
            <li class="feature-item" *ngFor="let feature of studentPackages.package_features">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>

              <div class="feature-content">
                <span class="feature-text">{{feature.feature_name}}</span>
                <span class="count-badge">{{feature.description}}</span>
              </div>
            </li>
          </ul>

        <button
          type="button"
          class="subcribe current-plan"
		 (click)="openReferralCodeDialogBox(studentPackages.product_id, studentPackages.pricing_id, 
          studentPackages.product_name, studentPackages.price)">
          <i class="bi bi-check-circle me-1"></i>Upgrade Plan
        </button>
      </div>
	  </div>
	  </ng-container>

      <!--career  -->
      <div class="plan-card basic most" *ngIf="starterProPackages">

        <div class="card-content">
          <h3>{{starterProPackages.product_name}}</h3>

          <div class="mb-2 price-wrapper">
            <span class="price text-center">
              <i class="bi bi-currency-rupee"></i>{{starterProPackages.price}} </span>
          </div>

          <p class="content">Essential career preparation to help you start your journey with confidence.</p>
          <hr />

          <div class="test text-start">What's Included :</div>

          <ul class="list-unstyled features-list">
            <li class="feature-item" *ngFor="let feature of starterProPackages.package_features">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>

              <div class="feature-content">
                <span class="feature-text">{{feature.feature_name}}</span>
                <span class="count-badge">{{feature.description}}</span>
              </div>
            </li>
          </ul>

          <button class="subcribe most-popular"
            (click)="openReferralCodeDialogBox(starterProPackages.product_id, starterProPackages.pricing_id, starterProPackages.product_name, starterProPackages.price)">
            <i class="bi bi-lightning-charge"></i>
            Upgrade Plan
          </button>
        </div>
      </div>

      <!-- elite -->

      <div class="plan-card basic elite-tech coming-soon-card">

        <div class="coming-soon-overlay">
          <i class="bi bi-hourglass-split"></i>
          <span>Coming Soon</span>
        </div>

        <div class="card-content">
          <h3>Elite Tech Career</h3>

          <div class="mb-2 price-wrapper">
            <span class="price text-center"> <i class="bi bi-currency-rupee"></i>4,999 </span>
          </div>

          <p class="content"> For serious tech professionals aiming for top roles</p>
          <hr />
          <div class="test text-start">What's Included :</div>

          <ul class="list-unstyled features-list">
            <li class="feature-item">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>
              <span class="feature-text">Professional Courses</span>
              <span class="count-badge">10+ AI & Cyber Security</span>
            </li>

            <li class="feature-item">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>
              <span class="feature-text">Course-wise Quizzes</span>
              <span class="count-badge">✔</span>
            </li>

            <li class="feature-item">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>
              <span class="feature-text">AI Mock Questions</span>
              <span class="count-badge">120</span>
            </li>

            <li class="feature-item">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>
              <span class="feature-text">AI Interview Practise</span>
              <span class="count-badge">60 min</span>
            </li>

            <li class="feature-item">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>
              <span class="feature-text">Expert Mentorship</span>
              <span class="count-badge">Paid Add-on</span>
            </li>

            <li class="feature-item">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>
              <span class="feature-text">Detailed AI Reports</span>
              <span class="count-badge">Advanced</span>
            </li>

            <li class="feature-item">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>
              <span class="feature-text">AI Resume Builder </span>
              <span class="count-badge">✔</span>
            </li>

            <li class="feature-item">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>
              <span class="feature-text">Career Roadmap</span>
              <span class="count-badge">✔</span>
            </li>

            <li class="feature-item">
              <span class="icon-circle">
                <i class="bi bi-check text-success"></i>
              </span>
              <span class="feature-text">Advanced Tech Courses</span>
              <span class="count-badge">✔</span>
            </li>
          </ul>

          <button class="subcribe tech" type="button" disabled>
            <i class="bi bi-lightning-charge"></i>
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Yearly Template -->
  <ng-template #yearlyPlansTemplate>
    <div class="plan-cards">
      <div class="plan-card basic">
        <div class="icon-square">
          <i class="bi bi-book-half"></i>
        </div>
        <h3>Basic</h3>
        <p class="price">
          <i class="bi bi-currency-rupee"></i>0 <span>/month</span>
        </p>
        <p class="content">
          Best for individuals or educators exploring AI-based course creation.
        </p>
        <ul class="list-unstyled">
          <li>
            <span class="icon-circle"><i class="bi bi-check text-success"></i></span>
            Classrooms (<span class="count-bold">4</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check text-success"></i></span>
            Students per Classroom (<span class="count-bold">20</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check text-success"></i></span>
            AI Courses (<span class="count-bold">2</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check text-success"></i></span>
            AI Quizzes (<span class="count-bold">2</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check text-success"></i></span>
            AI Questions / Quiz (<span class="count-bold">10</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check text-success"></i></span>
            AI Quiz Evaluations (<span class="count-bold">40</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check text-success"></i></span>
            Analytics Dashboard (<span class="count-bold">Basic</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-x text-dark"></i></span>
            Custom Branding
          </li>
        </ul>
        <button class="subcribe" [routerLink]="['/login']">
          Get Started <i class="bi bi-arrow-right"></i>
        </button>
      </div>

      <div class="plan-card pro popular">
        <div class="popular-top">
          <i class="bi bi-star-fill text-white me-1"></i> Most Popular
        </div>
        <div class="icon-square">
          <i class="bi bi-star-fill text-warning"></i>
        </div>
        <h3>Pro</h3>
        <p class="price">
          <i class="bi bi-currency-rupee"></i>7999 <span>/year</span>
        </p>
        <p class="content">
          Best for individuals or educators exploring AI-based course creation.
        </p>
        <ul class="list-unstyled">
          <li>
            <span class="icon-circles"><i class="bi bi-check text-success"></i></span>
            Classrooms (<span class="count-bold">40</span>)
          </li>
          <li>
            <span class="icon-circles"><i class="bi bi-check text-success"></i></span>
            Students per Classroom (<span class="count-bold">50</span>)
          </li>
          <li>
            <span class="icon-circles"><i class="bi bi-check text-success"></i></span>
            AI Courses (<span class="count-bold">10</span>)
          </li>
          <li>
            <span class="icon-circles"><i class="bi bi-check text-success"></i></span>
            AI Quizzes (<span class="count-bold">10</span>)
          </li>
          <li>
            <span class="icon-circles"><i class="bi bi-check text-success"></i></span>
            AI Questions / Quiz (<span class="count-bold">50</span>)
          </li>
          <li>
            <span class="icon-circles"><i class="bi bi-check text-success"></i></span>
            AI Quiz Evaluations (<span class="count-bold">500</span>)
          </li>
          <li>
            <span class="icon-circles"><i class="bi bi-check text-success"></i></span>
            Analytics Dashboard (<span class="count-bold">Advance</span>)
          </li>
          <li>
            <span class="icon-circles"><i class="bi bi-x text-dark"></i></span>
            Custom Branding
          </li>
        </ul>
        <button (click)="openDemoPopup(upgradePricePlan.Pro)" class="subcribe">
          Contact Us <i class="bi bi-arrow-right"></i>
        </button>
      </div>

      <div class="plan-card Enterprise">
        <div class="icon-square">
          <i class="bi bi-trophy-fill text-warning"></i>
        </div>
        <h3>Enterprise</h3>
        <p class="price">
          <i class="bi bi-currency-rupee"></i>24999 <span>/year</span>
        </p>
        <p class="content">
          For large organizations managing hundreds of learners with scalability
          and custom branding.
        </p>
        <ul class="list-unstyled">
          <li>
            <span class="icon-circle"><i class="bi bi-check"></i></span>
            Classrooms (<span class="count-bold">Unlimited</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check"></i></span>
            Students per Classroom (<span class="count-bold">200</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check"></i></span>
            AI Courses (<span class="count-bold">Unlimited</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check"></i></span>
            AI Quizzes (<span class="count-bold">Unlimited</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check"></i></span>
            AI Questions / Quiz (<span class="count-bold">Unlimited</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check"></i></span>
            AI Quiz Evaluations (<span class="count-bold">40,000</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check"></i></span>
            Analytics Dashboard (<span class="count-bold ent">Full + export</span>)
          </li>
          <li>
            <span class="icon-circle"><i class="bi bi-check"></i></span>
            Custom Branding
          </li>
        </ul>
        <button (click)="openDemoPopup(upgradePricePlan.Enterprise)" class="subcribe">
          Contact Us <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    </div>
  </ng-template>

  <div>
    <section class="faq-section">
      <h2 class="faq-title">Frequently Asked Questions</h2>

      <div class="faq-grid">
        <div class="faq-card">
          <h4>Can I upgrade my plan later?</h4>
          <p>
            Yes, you can upgrade your plan once your current plan is completed. The new plan will be charged at full
            price.
          </p>
        </div>

        <div class="faq-card">
          <h4>What payment methods are accepted?</h4>
          <p>
            We accept all major credit/debit cards, UPI, and net banking through our secure Razorpay payment gateway
          </p>
        </div>

        <div class="faq-card">
          <h4>Is there a refund policy?</h4>
          <p>
            No, we do not offer refunds for any plans once the purchase is completed. Please review the plan details
            carefully before upgrading.
          </p>
        </div>

        <div class="faq-card">
          <h4>How long is the access valid?</h4>
          <p>
            Once you reach the limits of your current plan (such as interview time, mock tests, or question generation),
            you’ll be prompted to upgrade to continue uninterrupted access.
          </p>
        </div>
      </div>
    </section>
  </div>
</div>